import { useState } from 'react';
import { Show, SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import ThumbnailField from '../../common/ThumbnailField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import AssignedEcomProductList from '../../common/ecom-products/AssignedEcomProductList';
import CommonModal from '../../common/ui/CommonModal';
import BulkUploadCreate from '../bulk-uploads/BulkUploadCreate';
import { FileUpload } from '@mui/icons-material';

const ProgramShow = () => {
    const params = useParams();
    const [activeTab, setActiveTab] = useState(0);
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();
    const [bulkUploadModal, setBulkUploadModal] = useState(false);

    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { id } = useParams();
    if (!id) {
        return <LoadingSection />;
    }

    const tabData = [
        {
            label: 'Details',
            content: (
                <div>
                    <Show actions={<> </>} title={<ProgramTitle />} resource={'programs'} id={id}>
                        <SimpleShowLayout>
                            <ThumbnailField size={'large'} source="image" />
                            <TextField source="name" fullWidth />
                            <TextField source="slug" fullWidth />
                            <TextField source="displayOrder" fullWidth />
                            <TextField source="lecturesCount" fullWidth />
                            <TextField source="exerciseCount" fullWidth />
                            <TextField source="homeworksCount" fullWidth />
                            <TextField source="notesCount" fullWidth />
                            <TextField source="totalExercises" fullWidth />
                            <TextField source="totalLectureDurationsInSeconds" fullWidth />
                            <TextField source="videosCount" fullWidth />
                            <TextField source="totalVideos" fullWidth />
                            <FormattedDateTimeField source="createdAt" fullWidth />
                            <FormattedDateTimeField source="updatedAt" fullWidth />
                            <TextField source="status" />
                        </SimpleShowLayout>
                    </Show>
                </div>
            ),
        },

        {
            label: 'Product Details',
            content: (
                <Show actions={<></>} id={id} resource={'programs'}>
                    <AssignedEcomProductList
                        type="program"
                        typeId={params.id}
                        refreshKey={refreshKey}
                    />
                </Show>
            ),
        },
        {
            label: 'Users',
            content: (
                <div>
                    <AssignedUserList type="programs" typeId={params.id} refreshKey={refreshKey} />
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="flex justify-end mx-10 gap-8 pt-5 pb-2">
                <AssignEcomProductModal
                    type="program"
                    typeId={params.id}
                    title="Assign Program"
                    onSuccess={handleAssignSuccess}
                />
                <div className="flex text-sm font-semibold   gap-2 justify-start text-[#4f3cc9]  items-center cursor-pointer hover:bg-blue-50">
                    <button
                        onClick={() => setBulkUploadModal(true)}
                        className="flex items-center uppercase gap-2"
                    >
                        <FileUpload fontSize="small" /> Bulk Assign
                    </button>
                </div>
            </div>
            <div className="rounded-md border">
                <div className="border-b py-2 flex text-lg flex-row gap-16 px-10 mb-6 rounded-t-md bg-white">
                    {tabData.map((tab, index) => (
                        <div
                            key={index}
                            onClick={() => handleTabClick(index)}
                            className={`hover:cursor-pointer ${
                                index === activeTab
                                    ? 'text-[#4f3cc9] underline decoration-4 underline-offset-[10px]'
                                    : ''
                            }`}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>

                <div className="tab-content bg-white px-2 pb-6">{tabData[activeTab].content}</div>
            </div>

            <CommonModal
                title="Assign Student Bulk Upload"
                open={bulkUploadModal}
                setOpen={setBulkUploadModal}
            >
                <BulkUploadCreate selectedType="PROGRAM_STUDENT" />
            </CommonModal>
        </>
    );
};

const ProgramTitle = () => {
    const record = useRecordContext();
    return <span className="capitalize">{record ? `${record.name}` : ''}</span>;
};
export default ProgramShow;
